import { OBSTACLE_SUBTYPE, OBSTACLE_TYPE } from "./../ENUM.js";
import * as GAME from "./../GAME.js";
import * as GRADIENT from "./../GRADIENT.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const STRRY = {
  isDark: true,
  startHealth: 50,
  timeAllowedSecs: 100,
  textColor: "#ffff00",
  textColorHighlight: "#ffffff",
  bgColor: "#001050",
  bgFadeAlpha: 0.7,
  gameplayAreaToCanvasLateralRatio: 0.8,
  player: {
    color: "#ffffff",
    growthDivisor: 600,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      subtype: OBSTACLE_SUBTYPE.SKEWED_CIRCLE,
      total: 7,
      color_ar: ["#999900"],
      radiusRange: [85, 85],
      directionRange: [180, 180],
      speedRange: [GAME.STATIC_OBSTACLE_SPEED, GAME.STATIC_OBSTACLE_SPEED],
      gradient: GRADIENT.GALAXY,
      //numAppendagesRange: [15, 19],
      //shapeCenterRadiusDivisor: 2,
      //shapeCenterColor_ar: ["#cccc00"],
    },
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 200,
      color_ar: ["#ffffff"],
      radiusRange: [2, 5],
      directionRange: [180, 180],
      speedRange: [1, 1],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      subtype: OBSTACLE_SUBTYPE.STAR,
      total: 100,
      color_ar: ["#ffff00", "#cccc00"],
      radiusRange: [15, 25],
      directionRange: [170, 160],
      speedRange: [0.5, 1],
      numAppendagesRange: [4, 7],
      rotationSpeedRange: [0.01, 0.1],
      shapeCenterRadiusDivisor: 7,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      subtype: OBSTACLE_SUBTYPE.STAR,
      total: 100,
      color_ar: ["#ffff00", "#cccccc"],
      radiusRange: [35, 40],
      directionRange: [170, 160],
      speedRange: [1.5, 2],
      numAppendagesRange: [4, 7],
      rotationSpeedRange: [0.01, 0.2],
      shapeCenterRadiusDivisor: 4,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 1,
      color_ar: ["#ffffff"],
      radiusRange: [35, 55],
      directionRange: [120, 240],
      speedRange: [1, 2],
      gradient: GRADIENT.STRAWBERRY_MOON,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 1,
      color_ar: ["#ffffff"],
      radiusRange: [35, 55],
      directionRange: [120, 240],
      speedRange: [1, 2],
      gradient: GRADIENT.MOON,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 1,
      color_ar: ["#ffffff"],
      radiusRange: [100, 135],
      directionRange: [120, 240],
      speedRange: [1, 2],
      gradient: GRADIENT.STRAWBERRY_MOON,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 1,
      color_ar: ["#ffffff"],
      radiusRange: [100, 135],
      directionRange: [120, 240],
      speedRange: [1, 2],
      gradient: GRADIENT.MOON,
    },
  ],
};
